// External dependencies
import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';

// Internal dependencies
import TeacherSelections from '../../../Reports/containers/TeacherSelections';
import CustomBenchmarkForm from '../blocks/CustomBenchmarkForm';

class CustomBenchmark extends Component {
  render () {
    const selectionProps = {
      isAggregateReport: true,
      disabledRostering: true,
      hasScoreScaling: true,
      pageTitle: "Custom Benchmark",
    };

    // TODO: teacher selections currently expects to receive selectedMetric and selectedScale
    // from it's parent. Refactor this out.
    return (
      <div className="reports-root-container">
        <div className="reports-page-wrap">
          <div className='reports-page'>
            <TeacherSelections
              teacherSelectionTypes={selectionProps}
              selectedMetric={this.props.selectedMetric}
              selectedScale={this.props.selectedScale}
              history={this.props.history}
              isAdminReport={true}
            />
            <div className="reports-container customBenchmarkContainer">
              <CustomBenchmarkForm
                selectedMetric={this.props.selectedMetric}
                selectedScale={this.props.selectedScale}
                district={this.props.district}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    selectedMetric: get(state, 'reports.teacher.selections.metric', {}),
    selectedScale: get(state, 'reports.teacher.selections.scale', {}),
    district: state.reports.roster.data && state.reports.roster.data.district ? state.reports.roster.data.district[0] : null,
  }
};

export default connect(mapStateToProps)(CustomBenchmark);